import { EMPTY_LIST } from '../../../../constants/common'
import { ROUTE_UI_SECTION_NAME } from '../../../../constants/route'
import { getItemsIds } from '../../../../utils/common'
import { getRequestProfilePathname } from '../../../../utils/link'
import { EmailTableCellName } from '../../Email.enums'

import { EMAIL_ATTACH_REQUEST_STATUS_NOTIFICATION_KEYS } from './useEmailAttachRequest.constants'

function getEmailAttachRequestStatusNotificationKeys({ archived, status }) {
  if (!status) {
    return null
  }

  return EMAIL_ATTACH_REQUEST_STATUS_NOTIFICATION_KEYS[
    archived ? 'restored' : 'statusChanged'
  ]
}

export function getEmailAttachRequestExcludeRequestIds(item) {
  return getItemsIds(item[EmailTableCellName.LinkedRequests])
}

export function getEmailAttachRequestPayload({ entityId, id, status }) {
  const payload = {
    email_message: entityId,
    requestId: id,
  }

  if (status) {
    payload.request_status = status
  }

  return payload
}

export function getEmailAttachRequestErrorKey({ archived, status }) {
  return (
    getEmailAttachRequestStatusNotificationKeys({ archived, status })?.error ||
    'Notification.EmailAttachRequestErrorKey'
  )
}

export function getEmailAttachRequestSuccessNotifications({
  archived,
  availableSections,
  id,
  name,
  status,
  successTitle,
  t,
}) {
  const statusNotificationKeys = getEmailAttachRequestStatusNotificationKeys({
    archived,
    status,
  })

  return [
    ...(statusNotificationKeys
      ? [
          {
            linkProps: {
              // full reload only for the legacy webapp profile
              reloadDocument:
                !availableSections[ROUTE_UI_SECTION_NAME.serviceRequest],
              title: t('Notification.CommonOpenProfileLinkKey'),
              to: getRequestProfilePathname({ availableSections, id }),
            },
            text: t(statusNotificationKeys.text, { name }),
            title: t(statusNotificationKeys.title),
          },
        ]
      : EMPTY_LIST),
    {
      title: successTitle,
    },
  ]
}
